var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WorkspaceChange',{ref:"workspaceChange"}),_c('div',{ref:"blocklyDiv",staticClass:"blocklyDiv"}),_c('xml',{ref:"blocklyToolbox",staticStyle:{"display":"none"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }